
import React, { useState, useRef } from "react";
import emailjs from "@emailjs/browser";
import Modal from "react-modal";
import "./HotelCollabForm.css";

Modal.setAppElement("#root");

const HotelCollabForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    hotelName: "",
    email: "",
    location: "",
    type: "",
    interest: "",
    message: "",
    form_type: "Hotel Collaboration",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [thankYouModal, setThankYouModal] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    emailjs
      .send(
        "service_rkd3nje",
        "template_t8nu1ry",
        formData,
        "jb85tG8nJgXDnDBVa"
      )
      .then(() => {
        setIsSubmitting(false);
        setThankYouModal(true);
        setFormData({
          name: "",
          hotelName: "",
          email: "",
          location: "",
          type: "",
          interest: "",
          message: "",
          form_type: "Hotel Collaboration",
        });
      })
      .catch(() => {
        setIsSubmitting(false);
        alert("Something went wrong. Please try again.");
      });
  };

  return (
    <section
      id="partner"
      style={{
        padding: "80px 20px",
        backgroundImage: "url(/partner-bg.jpg)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundColor: "#f9fafb",
        position: "relative",
      }}
    >
      <div
        className="hotel-form-container"
        style={{
          maxWidth: "720px",
          margin: "0 auto",
          padding: "40px 32px",
          backgroundColor: "rgba(255, 255, 255, 0.84)",
          borderRadius: "16px",
          boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
          backdropFilter: "blur(4px)",
        }}
      >
        <h2
          style={{
            fontSize: "36px",
            fontWeight: "700",
            textAlign: "center",
            marginBottom: "12px",
          }}
        >
          🤝 Partner With Us
        </h2>
        <p
          style={{
            textAlign: "center",
            fontSize: "16px",
            color: "#374151",
            marginBottom: "28px",
            maxWidth: "580px",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          Are you a boutique hotel, luxury resort, homestay, or villa looking to
          grow your visibility and bookings? TravXplo offers an exclusive
          influencer partnerships, digital marketing, and verified listings.
          Let’s work together!
        </p>
        <form className="hotel-form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            required
            value={formData.name}
            onChange={handleChange}
          />
          <input
            type="text"
            name="hotelName"
            placeholder="Hotel / Resort Name"
            required
            value={formData.hotelName}
            onChange={handleChange}
          />
          <input
            type="email"
            name="email"
            placeholder="Email Address"
            required
            value={formData.email}
            onChange={handleChange}
          />
          <input
            type="text"
            name="location"
            placeholder="Hotel Location"
            required
            value={formData.location}
            onChange={handleChange}
          />

          <select
            name="type"
            required
            value={formData.type}
            onChange={handleChange}
          >
            <option value="">Type of Property</option>
            <option value="Boutique Hotel">Boutique Hotel</option>
            <option value="Luxury Resort">Luxury Resort</option>
            <option value="Homestay">Homestay</option>
            <option value="Villa">Villa</option>
            <option value="Other">Other</option>
          </select>

          <select
            name="interest"
            required
            value={formData.interest}
            onChange={handleChange}
          >
            <option value="">Interested In</option>
            <option value="Influencer Collaboration">
              Influencer Collaboration
            </option>
            <option value="Digital Marketing">Digital Marketing</option>
            <option value="Verified Hotel Program">
              Verified Hotel Program
            </option>
            <option value="Reels / Campaign Bundle">
              Reels / Campaign Bundle
            </option>
          </select>

          <textarea
            name="message"
            placeholder="Tell us more..."
            rows="4"
            value={formData.message}
            onChange={handleChange}
          ></textarea>

          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Submitting..." : "Submit"}
          </button>
        </form>
      </div>

      {/* ✅ Thank You Modal */}
      <Modal
        isOpen={thankYouModal}
        onRequestClose={() => setThankYouModal(false)}
        className="thankyou-modal"
        overlayClassName="modal-overlay"
      >
        <div className="thank-you-box">
          <div className="checkmark">✅</div>
          <h3>Thank you!</h3>
          <p>We’ll be in touch with you shortly.</p>
          <button onClick={() => setThankYouModal(false)}>Close</button>
        </div>
      </Modal>
    </section>
  );
};

export default HotelCollabForm;
